import { render, staticRenderFns } from "./EmailDialogToggle.vue?vue&type=template&id=bc779712&"
import script from "./EmailDialogToggle.vue?vue&type=script&lang=js&"
export * from "./EmailDialogToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports